import React, { Component  } from 'react'
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import CarDetails from './CarDetails'

var imageStyle = {
    width:'100%',
    height:'100%'
}
var buttonStyle = {
    width:'50%',
    height:'100%',
    //z-index has to be less than the popup otherwise it will show
    zIndex:0
}

export default class CarInfo extends Component {
    constructor(props){
        super(props);
        this.escFunction = this.escFunction.bind(this);
    }

    state = {
        isDetailsOpen: false,
        fullText : this.props.data.name+this.props.data.model
    }

    escFunction(event){
        //if the escape key is pressed or anywhere outside the popup box is clicked then close the popup 
        //(for some reason it considers anything outside the actual box to have a className of popup-box)        
        if(event.keyCode === 27 || event.target.className === 'popup-box') {
            this.setState({isDetailsOpen:false})
        }
    }

    componentDidMount(){
        document.addEventListener("keydown", this.escFunction, false);
        document.addEventListener("click", this.escFunction, false);
    }
    componentWillUnmount(){
        document.removeEventListener("keydown", this.escFunction, false);
    }

    togglePopup = () => {
        this.setState({isDetailsOpen:!this.state.isDetailsOpen});
    }
    render() {
        return (
            <Grid container>
                <Grid item xs={12} >
                    {this.state.isDetailsOpen ? <CarDetails data={this.props.data} handleClose={this.togglePopup} />: null}
                </Grid>
                <Grid item xs={12} style={{height:'21vh'}}>
                    <img src={('http://polarize.info:5000/static/'+this.props.data.Manufacturer + this.props.data.Model + this.props.data.Year+'.jpg').replace(/\s+/g, '')} style={imageStyle} 
                    alt={"A " + this.props.data.Manufacturer + " " + this.props.data.Model + " " + this.props.data.Year}></img>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="text" disabled style={{minHeight:'2vh', width:'50%', fontSize:'1vh', height:'100%', color:'black'}}> {this.props.data.Manufacturer + " " + this.props.data.Model + " (" + this.props.data.Year + ")"}</Button>
                    <Button variant="outlined"  style={buttonStyle} onClick={this.togglePopup}>Details</Button>
                </Grid>
                <Grid item xs={12}>
                    <Button variant="text" disabled style={{minHeight:'2vh', maxHeight:'2vh', width:'50%', fontSize:'1.25vh', height:'100%', color:'green'}}>${this.props.data.Price}</Button>
                    <Button variant="outlined" style={buttonStyle} target="_blank" href={"https://www.google.com/maps/search/"+this.props.data.Manufacturer +" dealership"}>Find Dealer</Button>
                </Grid>
            </Grid>
        );
    }
}
